import { jsx as _jsx } from "react/jsx-runtime";
import { getTicketTypeById } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { TicketPickerContextInstance } from '../types/context';
import { sortTickets } from '../utils/sort-tickets';
const b = bemClassBuilder('v-ticket-picker-table-body');
export const TicketPickerTableBody = observer(props => {
    const { tickets, onTicketQuantityChanged } = props;
    const { subcomponents } = useContext(TicketPickerContextInstance);
    const { Row } = subcomponents;
    const sortedTickets = sortTickets(tickets);
    return (_jsx("div", Object.assign({ className: b.block() }, { children: sortedTickets.map(ticket => {
            const ticketType = getTicketTypeById(ticket.ticketTypeId);
            return (_jsx(Row, { ticket: ticket, ticketType: ticketType, onTicketQuantityChanged: onTicketQuantityChanged }, getKeyForTicket(ticket)));
        }) })));
});
TicketPickerTableBody.displayName = 'TicketPickerTableBody';
const getKeyForTicket = (ticket) => {
    return JSON.stringify(ticket);
};
